import { render, staticRenderFns } from "./ClassRemindersSchedule.vue?vue&type=template&id=6aa9f72e&scoped=true&"
import script from "./ClassRemindersSchedule.vue?vue&type=script&lang=js&"
export * from "./ClassRemindersSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ClassRemindersSchedule.vue?vue&type=style&index=0&id=6aa9f72e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9f72e",
  null
  
)

export default component.exports